import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseCompetingTimeSlotsComponent } from '../../abstract-components/base-competing-time-slots.component';

@Component({
  selector: 'competing-time-slots-layout',
  standalone: false,
  templateUrl: './competing-time-slots-layout.component.html',
  styleUrl: './competing-time-slots-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompetingTimeSlotsLayoutComponent extends BaseCompetingTimeSlotsComponent {}
